import { ReactNode } from "react";
import AccordionIcon from "../assets/icons/instruments/accordionIcon";
import ViolinIcon from "../assets/icons/instruments/violinIcon";


import CelloIcon from "../assets/icons/instruments/celloIcon";
import DoubleBassIcon from "../assets/icons/instruments/doubleBassIcon";
import ElectricGuitarIcon from "../assets/icons/instruments/electricGuitarIcon";
import GuitarIcon from "../assets/icons/instruments/guitarIcon";
import InstrumentPlaceholderIcon from "../assets/icons/instruments/instrumentPlaceholderIcon";
import PianoIcon from "../assets/icons/instruments/pianoIcon";
import TenorSaxophoneIcon from "../assets/icons/instruments/tenorSaxophone";
import ThereminIcon from "../assets/icons/instruments/thereminIcon";
import ViolaIcon from "../assets/icons/instruments/violaIcon";
import { InstrumentAmountDTOInstrumentEnum } from "../openapi-generated-client";
import BassAccordionIcon from "../assets/icons/instruments/bassAccordionIcon";
import TenorTromboneIcon from "../assets/icons/instruments/tenorTromboneIcon";

enum InstrumentationType {
    Solo = "Solo",
    ChamberMusic = "Chamber Music",
    OrchestralPiece = "Orchestral Piece"
}

class Instrument {
    name: string;
    id: number;
    icon: ReactNode;

    constructor(id: number, name: string, icon: ReactNode) {
        this.id = id;
        this.name = name;
        this.icon = icon;
    }

    toEnum(): InstrumentAmountDTOInstrumentEnum | undefined {
        const entries = Object.entries(InstrumentAmountDTOInstrumentEnum);
        return entries[this.id] ? entries[this.id][1] as InstrumentAmountDTOInstrumentEnum : undefined;
    }
}

const instrumentIcons = {
    [InstrumentAmountDTOInstrumentEnum.Accordion]: <AccordionIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Violin]: <ViolinIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Cello]: <CelloIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Viola]: <ViolaIcon/>,
    [InstrumentAmountDTOInstrumentEnum.DoubleBass]: <DoubleBassIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Guitar]: <GuitarIcon/>,
    [InstrumentAmountDTOInstrumentEnum.ElectricGuitar]: <ElectricGuitarIcon/>,
    [InstrumentAmountDTOInstrumentEnum.AcousticGuitar]: <GuitarIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Piano]: <PianoIcon/>,

    [InstrumentAmountDTOInstrumentEnum.TenorSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.AltoSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Saxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.BassSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.SopranoSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.BaritoneSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.SopraninoSaxophone]: <TenorSaxophoneIcon/>,
    [InstrumentAmountDTOInstrumentEnum.ContrabassSaxophone]: <TenorSaxophoneIcon/>,

    [InstrumentAmountDTOInstrumentEnum.Theremin]: <ThereminIcon/>,
    [InstrumentAmountDTOInstrumentEnum.BassAccordion]: <BassAccordionIcon/>,
    [InstrumentAmountDTOInstrumentEnum.Trombone]: <TenorTromboneIcon/>,
}
const defaultIcon = <InstrumentPlaceholderIcon/>

function getIdByInstrumentEnum(value: string): number | undefined {
    // Get all entries from the enum as [key, value] pairs
    const entries = Object.entries(InstrumentAmountDTOInstrumentEnum);
    
    // Find the index of the entry matching the given value
    const index = entries.findIndex(([, enumValue]) => enumValue === value);
    
    // Return index (ID as number), or undefined if not found
    return index >= 0 ? index : undefined;
}

function getInstrumentEnumById(id: number): InstrumentAmountDTOInstrumentEnum | undefined {
    const entries = Object.entries(InstrumentAmountDTOInstrumentEnum);
    return entries[id] ? entries[id][1] as InstrumentAmountDTOInstrumentEnum : undefined;
}

function formatName(name: string) {
    return name.replace("_", " ").trim();
}


function getInstrument(value: InstrumentAmountDTOInstrumentEnum) {
    if(getIdByInstrumentEnum(value) === undefined) {
        console.log("Instrument not found: " + value);
        return undefined;
    }
    const id = getIdByInstrumentEnum(value)!;
    const icon = instrumentIcons[value as keyof typeof instrumentIcons] || defaultIcon;
    return new Instrument(id, formatName(value), icon); 
}

export { getIdByInstrumentEnum, getInstrument, getInstrumentEnumById, Instrument, InstrumentationType };

